<template>
  <div class="code-field">
    <div class="label">
      验证码
    </div>
    <div class="value">
      <input
        type="number"
        pattern="\d*"
        oninput="value=value.replace(/[^\d]/g,'')"
        v-model="code"
        @input="onInput"
        placeholder="请输入验证码"
      />
      <span class="get-code" :style="{ color: color }" @click="getCode">{{
        getCodeText
      }}</span>
    </div>
  </div>
</template>
<script>
import { sendSmsCode } from "@/api/index.js";
import { encrypt } from "@/utils/crypto.js";

export default {
  name: "codeField",
  props: {
    value: {
      type: String,
      default: "",
    },
    phone: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      code: "",
      getCodeText: "获取验证码",
      timer: null,
      counter: 60,
      isSend: false,
      color: "#F24334",
    };
  },
  methods: {
    init() {
      clearInterval(this.timer);
      this.getCodeText = "获取验证码";
      this.timer = null;
      this.counter = 60;
      this.isSend = false;
      this.color = "#F24334";
    },
    onInput(val) {
      if (val.target.value.length > 6) {
        this.code = val.target.value.slice(0, 6);
      }
      this.$emit("input", this.code);
    },
    countDown() {
      this.timer = setInterval(() => {
        this.isSend = true;
        this.getCodeText = `${this.counter}秒后重发`;
        this.counter--;
        this.color = "rgba(51,51,51,0.4)";
        if (this.counter < 0) {
          this.getCodeText = "获取验证码";
          this.isSend = false;
          this.color = "#F24334";
          if (this.timer) {
            clearInterval(this.timer);
            this.counter = 60;
            this.timer = null;
          }
        }
      }, 1000);
    },
    getCode() {
      if (!this.phone) {
        this.$toast("请输入手机号");
        return;
      }
      if (this.isSend) return;
      sendSmsCode({
        phoneNumber: this.phone,
        captchaType:'Login',
        sign: encrypt(this.phone + 'Login'),
      }).then((res) => {
        if (res.code !== 2000) {
          this.$toast(res.msg || res.message || "请求失败");
          return;
        } else {
          this.countDown();
          this.$toast("验证码发送成功");
        }
      });
    },
  },
  watch: {
    value(newVal) {
      this.code = newVal;
    },
  },
};
</script>
<style scoped lang="scss">
.code-field {
  display: flex;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  .value {
    display: flex;
    align-items: center;
    padding: 10px 0px;
    border-bottom: 1px solid rgba(51,51,51,0.1);
    input {
      border: none;
      outline: none;
      background: transparent;
      width: 44%;
      &::placeholder {
        color: rgba(51, 51, 51, 0.4);
      }
    }
    .get-code {
      flex: 1;
      font-size: 14px;
      color: #1d70f7;
      margin-right: 18px;
      cursor: pointer;
      text-align: right;
    }
  }
}
</style>
